import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqFormService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/cq-forms', query);
  }

  create(body: any) {
    return this.post('/cq-forms', body);
  }

  find(id) {
    return this.get('/cq-forms/' + id);
  }

  update(id, body) {
    return this.put('/cq-forms/' + id, body);
  }

  _delete(id) {
    return this.delete('/cq-forms/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqForm.service.ts